import { getTravelerList } from '@/api/contact'

export default {
  updateTravelerListForLoginPage: async function ({ commit }, params) {
    return getTravelerList({
      passenger_source: 0,
      show_loading: false
    }).then(res => {
      commit("setTravelerList", res?.data?.list || [])
    })
  }
}
